import { AppState } from '../appState';

/**
 * Checks if the user is either properly logged in i.e. they have a JWT (auth.token),
 * so (as far as we know) there is no need to make the refresh token request,
 * or if the user is completely logged out i.e. they don't have a refresh token (auth.refreshToken),
 * so they need to enter their login+password to be logged in.
 */
export const userIsFullyLoggedInOrFullyLoggedOut = (state: AppState): boolean =>
    !!state.auth.token || !state.auth.refreshToken;
